import classNames from 'classnames';
import './index.css';

const TransitionPage = ({
  children,
  fade,
  className,
  timeout = 300,
}: {
  children: React.ReactNode;
  fade?: boolean;
  className?: string;
  timeout?: number;
}) => {
  return (
    <section
      className={classNames(`fade-${fade ? 'out' : 'in'}`, className)}
      style={{ animationDuration: `${timeout}ms` }}
    >
      {children}
    </section>
  );
};

export default TransitionPage;
